<template>
  <div>
    <keep-alive>
      <component :is="informComponent"
                 ref="listMethod"
                 @org-inform-view="orgInformView"
                 :param="param"
      >
      </component>
    </keep-alive>
  </div>
</template>

<script>
import OrgInformList from './OrgInformList'

export default {
  name: 'InformList',
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  components: {
    'org-inform-list': OrgInformList
  },
  data () {
    return {
      informComponent: 'org-inform-list'
    }
  },
  methods: {
    changeEvent (value) {
      this.$refs['listMethod'].changeEvent(value)
    },
    orgInformView (view, flag) {
      this.$emit('org-inform-view', view, flag)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
